import { render, staticRenderFns } from "./program.vue?vue&type=template&id=9302d16e&"
import script from "./program.vue?vue&type=script&lang=js&"
export * from "./program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9302d16e')) {
      api.createRecord('9302d16e', component.options)
    } else {
      api.reload('9302d16e', component.options)
    }
    module.hot.accept("./program.vue?vue&type=template&id=9302d16e&", function () {
      api.rerender('9302d16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/instruct/program.vue"
export default component.exports